const genericMapConstants = {
  GET_GENERIC_MAP_ROUTES: 'GET_GENERIC_MAP_ROUTES',
  GET_GENERIC_MAP_ROUTES_SUCCESS: 'GET_GENERIC_MAP_ROUTES_SUCCESS',
  GET_GENERIC_MAP_ROUTES_FAILURE: 'GET_GENERIC_MAP_ROUTES_FAILURE',

  GET_GENERIC_MAP_DATA: 'GET_GENERIC_MAP_DATA',
  GET_GENERIC_MAP_DATA_SUCCESS: 'GET_GENERIC_MAP_DATA_SUCCESS',
  GET_GENERIC_MAP_DATA_FAILURE: 'GET_GENERIC_MAP_DATA_FAILURE',

  SET_DISPLAYED_MAP_DATA: 'SET_DISPLAYED_MAP_DATA',

  GET_GENERIC_MAP_DRAWN_SHAPES: 'GET_GENERIC_MAP_DRAWN_SHAPES',
  GET_GENERIC_MAP_DRAWN_SHAPES_SUCCESS: 'GET_GENERIC_MAP_DRAWN_SHAPES_SUCCESS',
  GET_GENERIC_MAP_DRAWN_SHAPES_FAILURE: 'GET_GENERIC_MAP_DRAWN_SHAPES_FAILURE',

  SET_GENERIC_MAP_DRAWN_SHAPES: 'SET_GENERIC_MAP_DRAWN_SHAPES',
  SET_GENERIC_MAP_DRAWN_SHAPES_SUCCESS: 'SET_GENERIC_MAP_DRAWN_SHAPES_SUCCESS',
  SET_GENERIC_MAP_DRAWN_SHAPES_FAILURE: 'SET_GENERIC_MAP_DRAWN_SHAPES_FAILURE',

  SET_GENERIC_MAP_LAYERS: 'SET_GENERIC_MAP_LAYERS',
  SET_MAP_CORNER_COORDINATES: 'SET_MAP_CORNER_COORDINATES',
  SET_AGREEMENTS_VISIBLE_FLAG: 'SET_AGREEMENTS_VISIBLE_FLAG',

  SET_ZOOM_LEVEL: 'SET_ZOOM_LEVEL',

  SET_ZOOM_WARNING_BANNER_VISIBILITY: 'SET_ZOOM_WARNING_BANNER_VISIBILITY',

  SET_HIGHLIGHTED_MARKERS: 'SET_HIGHLIGHTED_MARKERS',

  SET_FILTER_TYPE: 'SET_FILTER_TYPE',
};

export default genericMapConstants;
